import * as React from 'react';

import {
  PaymentGatewayActionContext,
  PaymentGatewayValueContext,
} from './context';
import { usePaymentGatewayAction, usePaymentGatewayValue } from './hook';
import { initialState } from './initial';
import { reducer } from './reducer';

const PaymentGatewayFormContext = ({
  children,
  ...props
}: React.PropsWithChildren<typeof initialState>) => {
  const [state, dispatch] = React.useReducer(reducer, {
    ...initialState,
    ...props,
  });
  return (
    <PaymentGatewayValueContext.Provider value={state}>
      <PaymentGatewayActionContext.Provider value={dispatch}>
        {children}
      </PaymentGatewayActionContext.Provider>
    </PaymentGatewayValueContext.Provider>
  );
};

export {
  PaymentGatewayFormContext,
  usePaymentGatewayAction,
  usePaymentGatewayValue,
};
